// src/components/common/Unauthorized.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Shield, 
  AlertTriangle, 
  Home, 
  LogIn,
  ArrowLeft,
  Lock
} from 'lucide-react';

const Unauthorized = ({ 
  message = "You don't have permission to access this page.",
  showHomeButton = true,
  showLoginButton = false,
  showBackButton = true,
  customAction = null
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center">
      <div className="max-w-md w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header with decorative element */}
          <div className="relative h-32 bg-gradient-to-r from-red-500 to-red-600">
            <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
              <div className="bg-white rounded-full p-4 shadow-lg">
                <Shield className="w-16 h-16 text-red-500" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="pt-16 px-8 pb-8 text-center">
            {/* Warning Icon */}
            {/* <div className="flex justify-center mb-4">
              <div className="bg-red-100 rounded-full p-3">
                <AlertTriangle className="w-8 h-8 text-red-600" />
              </div>
            </div> */}

            {/* Title */}
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Access Denied
            </h1>

            {/* Message */}
            <p className="text-gray-600 mb-6">
              {message}
            </p>

            {/* Additional Info */}
            {/* <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <div className="flex items-start">
                <Lock className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
                <div className="text-left text-sm text-red-700">
                  <p className="font-medium mb-1">This area is restricted to:</p>
                  <ul className="list-disc list-inside space-y-1 text-red-600">
                    <li>Administrators</li>
                    <li>Editors-in-Chief</li>
                    <li>Associate Editors</li>
                    <li>Editorial Assistants</li>
                  </ul>
                </div>
              </div>
            </div> */}

            {/* Action Buttons */}
            {/* <div className="space-y-3">
              {showBackButton && (
                <button
                  onClick={() => navigate(-1)}
                  className="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Go Back
                </button>
              )}

              {showHomeButton && (
                <button
                  onClick={() => navigate('/')}
                  className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
                >
                  <Home className="w-4 h-4" />
                  Return to Home
                </button>
              )}

              {showLoginButton && (
                <button
                  onClick={() => navigate('/login')}
                  className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
                >
                  <LogIn className="w-4 h-4" />
                  Log In
                </button>
              )}

              {customAction && (
                <button
                  onClick={customAction.onClick}
                  className={`w-full px-4 py-3 ${customAction.className || 'bg-gray-600 hover:bg-gray-700'} text-white rounded-lg transition-colors flex items-center justify-center gap-2`}
                >
                  {customAction.icon}
                  {customAction.label}
                </button>
              )}
            </div> */}
          </div>

          {/* Footer */}
          <div className="px-8 py-4 bg-gray-50 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              If you believe this is an error, please contact your system administrator.
            </p>
          </div>
        </div>

        {/* Help Text */}
        <p className="text-center text-sm text-gray-500 mt-4">
          Need assistance? Contact support at{' '}
          <a href="mailto:support@asfirj.org" className="text-blue-600 hover:underline">
            support@asfirj.org
          </a>
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;